import { all, takeLatest, put, call } from 'redux-saga/effects';

import {
  apiFetchTutorAuditInfo,
  apiUpdateTutorAuditInfo,
  apiFetchTutorAuditColleges,
  apiFetchTutorAuditCollegeMajors,
  apiSubmitTutorAudit,
} from '@dragonfruit/services/apis';

import * as actions from '@dragonfruit/redux/tutorAudit';
import { account } from '@dragonfruit/redux/navigation';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import { actions as errorActions } from '@dragonfruit/redux/error';

import {
  CERTIFICATE_TYPE_ID,
  CERTIFICATE_FILE,
} from '@dragonfruit/constants/tutorCertificateFields';
import { ALERT_ERROR_THEME } from '@dragonfruit/constants/alertBannerThemes';

import { fetchUserInfo } from './profile';

export function* fetchTutorAuditInfoFlow() {
  try {
    const {
      qualificationTestTypes: qualifications,
      tutorCertificateTypes: certificatesRequired,
      tutorHandbook: tutorHandbookUrl,
      expectedSubjects: subjects,
      tutorIntroduction: introduction,
      selectedExpectedSubjectIds: selectedSubjectIds,
      finishedTutorCertificates: finishedCertificateIds,
      finishedQualificationTests: finishedQualificationIds,
      phoneVerificationRequired,
    } = yield call(apiFetchTutorAuditInfo);

    // need fill information that user has key in
    yield call(fetchUserInfo);

    yield put(
      actions.fetchTutorAuditInfoSuccess({
        qualifications,
        certificatesRequired,
        tutorHandbookUrl,
        subjects,
        introduction,
        selectedSubjectIds,
        finishedCertificateIds,
        finishedQualificationIds,
        phoneVerificationRequired,
      })
    );
  } catch (err) {
    yield put(actions.fetchTutorAuditInfoError(err.message));
    yield put(errorActions.sendError(err));
  }
}

export function* updateTutorCertificate(action) {
  const { certificateFile, certificateTypeId } = action.payload;

  try {
    const data = new FormData();
    data.append(CERTIFICATE_TYPE_ID, certificateTypeId);
    data.append(CERTIFICATE_FILE, certificateFile, certificateFile.name);

    yield call(apiUpdateTutorAuditInfo, data);

    yield put(actions.updateSuccess());
  } catch (err) {
    yield put(actions.updateError(err.message));
    // ignore error from API
    if (!err.error_code) {
      yield put(errorActions.sendError(err));
    }
  }
}

export function* fetchAuditCollegesFlow() {
  try {
    const collegeList = yield call(apiFetchTutorAuditColleges);
    yield put(actions.fetchAuditCollegesSuccess(collegeList));
  } catch (err) {
    yield put(actions.fetchAuditCollegesFailure(err.error_message));
  }
}

export function* fetchAuditMajorsFlow(action) {
  const { collegeId } = action.payload;
  try {
    try {
      const majorList = yield call(apiFetchTutorAuditCollegeMajors, collegeId);
      yield put(actions.fetchAuditMajorsSuccess(majorList));
    } catch (err) {
      yield put(actions.fetchAuditMajorsFailure(err.error_message));
    }
  } catch (err) {}
}

export function* confirmTutorAuditFlow() {
  try {
    yield call(apiSubmitTutorAudit);
    yield put(actions.confirmTutorAuditSuccess());
    yield put(account());
  } catch (err) {
    yield put(
      showAlertBanner({
        theme: ALERT_ERROR_THEME,
        message: err.message,
      })
    );
    yield put(actions.confirmTutorAuditFailure(err.error_message));
  }
}

export default function*() {
  yield all([
    takeLatest(actions.FETCH_TUTOR_AUDIT_INFO, fetchTutorAuditInfoFlow),
    takeLatest(actions.UPDATE_TUTOR_CERTIFICATE, updateTutorCertificate),
    takeLatest(actions.FETCH_AUDIT_COLLEGES, fetchAuditCollegesFlow),
    takeLatest(actions.FETCH_AUDIT_MAJORS, fetchAuditMajorsFlow),
    takeLatest(actions.CONFIRM_TUTOR_AUDIT, confirmTutorAuditFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/tutorAudit.js